module.exports = __webpack_public_path__ + "static/sc-01.d3c816dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/transperception/sc-01.png
// module id = 95
// module chunks = 88197199937824 143459317370244 213720915766396